



























































































import Vue from 'vue'

export default Vue.extend({
  name: 'TaskExamplesModal',

  props: {
    modalVisible: {
      type: Boolean,
      required: true,
    },
    taskType: {
      type: Object,
      required: true,
    },
    hashTags: {
      type: Array,
      default: () => [],
    },
    mentions: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    isVideo: function () {
      return this.taskType.verb === 'Video'
    },
    isReview: function () {
      return this.taskType.verb === 'Review'
    },
    socialTagsHelpText: function () {
      if (this.isVideo) {
        return { title: 'Use the Required Hashtags', icon: 'mdi-pound', text: 'Make sure to add the required hashtags to your video.' }
      }
      if (this.hashTags.length === 0 && this.mentions.length > 0) {
        return { title: 'Use the Required Tags', icon: 'mdi-at', text: 'Make sure you tag the business.' }
      }

      if (this.hashTags.length > 0 && this.mentions.length === 0) {
        return { title: 'Use the Required Hashtags', icon: 'mdi-pound', text: 'Make sure you use the correct hashtags.' }
      }

      return { title: 'Use the Required Tags & Hashtags', icon: 'mdi-at', text: 'Make sure you tag the business and use the correct hashtags.' }
    },
  },
})
